import { UserCourseStatus } from './course.interface';

export enum UserRole {
  Admin = 'Admin',
  Assistant = 'Assistant',
  Instructor = 'Instructor',
  Player = 'Player',
}

export interface IUser {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  nickname?: string;
  lastAccessCourse: number;
  profileImage?: string;
  created?: string;
  modified?: string;
  lastLogin: Date;
  configuredLanguage: string;
  role: UserRole;
  courses: number[];
  courseCount: number;
  isActive: boolean;
  isEmailVerified: boolean;
  password?: string;
  passwordConfirm?: string;
  userCourses?: { course: number; status: UserCourseStatus; paid: boolean }[];
}
